module.exports = __webpack_public_path__ + "static/media/rocket-success.d30c0c23.svg";